/*
 * @Description: 注册全局自定义指令
 * @Date: 2021-03-22 00:53:10
 */
import { App } from 'vue';
import Resource from '@/directives/resource';
export function setupDirectives(app: App) {
  app.directive('resource', Resource);
}
